<header class="page-header">
  <div class="header-title">
    <div class="header-text">
      <h1>
        @if (iconName()) {
          <lib-icon
            [name]="$any(iconName())"
            [size]="24"
            class="inline-icon"
            [class.custom-color]="iconColor() !== undefined"
            [style.color]="iconColor()"
            aria-hidden="true"
          />
        }
        <span class="page-header__title-text" [attr.title]="title()">{{ title() }}</span>
      </h1>
      @if (subtitle()) {
        <p class="subtitle">{{ subtitle() }}</p>
      }
    </div>
  </div>

  <div class="header-actions">
    @for (action of actions(); track action.id) {
      @if (action.visible !== false) {
        @if (action.iconOnly) {
          <div
            class="action-button-wrapper action-button-wrapper--icon-only"
            [attr.title]="action.label"
            [attr.aria-label]="action.label"
          >
            <lib-button
              variant="icon-ghost"
              [disabled]="action.disabled || false"
              [prefixIcon]="$any(action.icon)"
              [iconSize]="20"
              [ariaLabel]="action.label"
              [loading]="action.loading || false"
              (clicked)="actionClick.emit(action.id)"
            />
          </div>
        } @else {
          <div class="action-button-wrapper desktop-only">
            <lib-button
              [variant]="action.variant || 'secondary'"
              [disabled]="action.disabled || false"
              [prefixIcon]="$any(action.icon)"
              [loading]="action.loading || false"
              (clicked)="actionClick.emit(action.id)"
            >
              {{ action.label }}
            </lib-button>
          </div>

          <div class="action-button-wrapper mobile-only">
            <div class="icon-button-with-tooltip" [attr.data-tooltip]="action.label">
              <lib-button
                [variant]="action.variant || 'secondary'"
                [disabled]="action.disabled || false"
                [prefixIcon]="$any(action.icon)"
                [loading]="action.loading || false"
                (clicked)="actionClick.emit(action.id)"
                class="icon-only-button"
              >
                <span class="sr-only">{{ action.label }}</span>
              </lib-button>
            </div>
          </div>
        }
      }
    }

    <ng-content select="[header-actions]"></ng-content>
  </div>
</header>
